import Grid from "../../../fragments/Grid";
import ExportWorkQGroupItem from "./ExportWorkQGroupItem";

export default function ExportWorkQGroup({items, actionModifier, groupName}) {

    return <Grid columns={5} gap={8}>
        {items.map(groupItem => (
            <div key={groupItem.key}>
                <ExportWorkQGroupItem item={groupItem} actionModifier={actionModifier} groupName={groupName}/>
            </div>
        ))}       
    </Grid>
}